import {Box, Link, Stack, styled} from "@mui/material";
import {ButtonPath} from "./tools";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {FormattedMessage} from "react-intl";

const Divider = () => <FontAwesomeIcon icon="chevron-right" display="flex" />;
const MenuLink = styled(Link)(() => ({
    cursor: "pointer",
}));
const CurrentMenuContainer = styled(Box)(() => ({
    cursor: "default",
}));

type MenuButtonProps = {
    path: number;
    index: number;
    last: boolean;
    goBack: (caller: number) => void; // which element called it
};

const MenuButton = ({path, index, last, goBack}: MenuButtonProps) => {
    const text = index === 0 ? <FormattedMessage id="ivr.rootMenu" defaultMessage="Main" /> : path;
    if (last) return <CurrentMenuContainer>{text}</CurrentMenuContainer>;
    return <MenuLink onClick={() => goBack(index)}>{text}</MenuLink>;
};

type MenuDisplayProps = {
    /** The current path of the menu */
    path: ButtonPath;
    /** Callback to update the path */
    newPathCallback: (newPath: ButtonPath) => void;
};

/**
 * Component that displays the current path of the menu in ivr profile settings
 * */
const MenuDisplay = ({path, newPathCallback}: MenuDisplayProps) => {
    return (
        <Stack direction="row" spacing={2} divider={<Divider />} alignItems="center">
            {[0].concat(path).map((element, index) => (
                <MenuButton
                    key={index}
                    path={element}
                    index={index}
                    last={index === path.length}
                    goBack={(caller) => newPathCallback(path.slice(0, caller))}
                />
            ))}
        </Stack>
    );
};

export default MenuDisplay;
